<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        Adult : {{ $store.state.dataitinerari.total_adult }} &nbsp;
        CNB : {{ $store.state.dataitinerari.total_cnb }} &nbsp;
        CWB : {{ $store.state.dataitinerari.total_cwb }} &nbsp;
      </v-col>
      <v-col>
        <v-simple-table>
          <thead>
            <tr>
              <th width="150">
                Name Cost
              </th>
              <th width="100">
                Cost
              </th>
              <th width="120">
                Mark Up
              </th>
              <th width="80">
                Qty
              </th>
              <th width="100">
                Total
              </th>
              <th width="100">
                Per Pax
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Cost For Adult</tD>
              <td>Rp. {{ Number(data_perhitungan.cost_for_adult).toLocaleString() }}</td>
              <td>
                <v-currency-field
                  v-model="data_perhitungan.markup_adult"
                  type="number"
                  hide-details
                  prefix="Rp."
                  dense
                  outlined
                  placeholder="Mark up Adult"
                  label="Mark up Adult"
                  @change="ProsesHitungAdult()"
                />
              </td>
              <td>
                <v-currency-field
                  v-model="data_perhitungan.qty_adult"
                  type="number"
                  hide-details
                  dense
                  outlined
                  placeholder="Qty"
                  label="Qty"
                  @change="ProsesHitungAdult()"
                />
              </td>
              <td>Rp. {{ Number(data_perhitungan.total_adult).toLocaleString() }}</td>
              <td>Rp. {{ Number(data_perhitungan.perpax_adult).toLocaleString() }}</td>
            </tr>
            <tr
              v-show="$store.state.dataitinerari.total_child > 0 "
            >
              <td>
                Cost For Child
              </td>
              <td>Rp. {{ Number(data_perhitungan.cost_for_child).toLocaleString() }}</td>
              <td>
                <v-currency-field
                  v-model="data_perhitungan.markup_child"
                  type="number"
                  hide-details
                  prefix="Rp."
                  dense
                  outlined
                  placeholder="Mark up Child"
                  label="Mark up Child"
                  @change="ProsesHitungChild()"
                />
              </td> <td>
                <v-currency-field
                  v-model="data_perhitungan.qty_child"
                  type="number"
                  hide-details
                  dense
                  outlined
                  placeholder="Qty "
                  label="Qty"
                  @change="ProsesHitungChild()"
                />
              </td>
              <td>Rp. {{ Number(data_perhitungan.total_child).toLocaleString() }}</td>
              <td>Rp. {{ Number(data_perhitungan.perpax_child).toLocaleString() }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
            </tr><tr>
              <th colspan="2"></th>
              <th>Rp. {{ Number(data_perhitungan.markup).toLocaleString() }}</th>
              <th> {{ Number(data_perhitungan.qty).toLocaleString() }}</th>
              <th>Rp. {{ Number(data_perhitungan.total).toLocaleString() }}</th>
              <th>Rp. {{ Number(data_perhitungan.perpax).toLocaleString() }}</th>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-right">
        <v-btn
          small
          class="mr-2 text-capitalize primary "
          @click="HitungService()"
        >
          Save Service
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  props: ['datahitung'],
  data() {
    return {
      data_perhitungan: [],
      render: true,
    }
  },
  mounted() {
    this.data_perhitungan = this.datahitung
    console.log(this.data_perhitungan)
  },
  created() {
    this.ProsesHitungChild()
    this.ProsesHitungAdult()
    this.$root.$emit('CountPerpax')
  },
  methods: {
    HitungService() {
      this.$root.$emit('CountPerpax')
      this.$root.$emit('HitungItinerary', this.data_perhitungan)
      this.data_perhitungan = []
    },
    ProsesHitungAdult() {
      // eslint-disable-next-line radix
      this.data_perhitungan.total_adult = (parseInt(this.data_perhitungan.cost_for_adult) + parseInt(this.data_perhitungan.markup_adult)) * parseInt(this.data_perhitungan.qty_adult)
      // eslint-disable-next-line radix
      if (this.data_perhitungan.qty_adult < 1) {
        // eslint-disable-next-line radix
        this.$root.$emit('PesanResponse', 'Qty Adult tidak boleh kurang dari 1', 'red')
        this.data_perhitungan.qty_adult = 1
        // eslint-disable-next-line radix
        this.data_perhitungan.perpax_adult = (Math.round(this.data_perhitungan.total_adult) / parseInt(this.data_perhitungan.qty_adult_awal))
      } else {
        // eslint-disable-next-line radix
        this.data_perhitungan.perpax_adult = Math.round(this.data_perhitungan.total_adult / parseInt(this.data_perhitungan.qty_adult_awal))
      }
      this.TotalHitung()
    },
    ProsesHitungChild() {
      // eslint-disable-next-line radix
      this.data_perhitungan.total_child = (parseInt(this.data_perhitungan.cost_for_child) + parseInt(this.data_perhitungan.markup_child)) * parseInt(this.data_perhitungan.qty_child)
      // eslint-disable-next-line radix

      if (this.data_perhitungan.qty_child < 1) {
        this.$root.$emit('PesanResponse', 'Qty Child tidak boleh kurang dari 1', 'red')
        this.data_perhitungan.qty_child = 0
        // eslint-disable-next-line radix
        this.data_perhitungan.perpax_child = Math.round(parseInt(this.data_perhitungan.total_child)) / parseInt(this.$store.state.dataitinerari.total_cnb) + parseInt(this.$store.state.dataitinerari.total_cwb)
      } else {
        // eslint-disable-next-line radix
        this.data_perhitungan.perpax_child = Math.round(parseInt(this.data_perhitungan.total_child)) / (parseInt(this.$store.state.dataitinerari.total_cnb) + parseInt(this.$store.state.dataitinerari.total_cwb))
      }
      this.TotalHitung()
    },
    TotalHitung() {
      // eslint-disable-next-line radix
      this.data_perhitungan.markup = parseInt(this.data_perhitungan.markup_child) + parseInt(this.data_perhitungan.markup_adult)
      // eslint-disable-next-line radix
      if ((this.$store.state.dataitinerari.total_cnb + this.$store.state.dataitinerari.total_cwb) > 0) {
      // eslint-disable-next-line radix
        this.data_perhitungan.total = parseInt(this.data_perhitungan.total_child) + parseInt(this.data_perhitungan.total_adult)
      } else {
      // eslint-disable-next-line radix
        this.data_perhitungan.total = parseInt(this.data_perhitungan.total_adult)
      }
      // eslint-disable-next-line radix
      if (this.data_perhitungan.perpax_child > 0) {
      // eslint-disable-next-line radix
        this.data_perhitungan.perpax = parseInt(this.data_perhitungan.perpax_child) + parseInt(this.data_perhitungan.perpax_adult)
      } else {
      // eslint-disable-next-line radix
        this.data_perhitungan.perpax = parseInt(this.data_perhitungan.perpax_adult)
      }
      // eslint-disable-next-line radix
      this.data_perhitungan.qty = parseInt(this.data_perhitungan.qty_child) + parseInt(this.data_perhitungan.qty_adult)

      this.$root.$emit('CountPerpax')
    },
  },
}
</script>
